// Display labels for the agent profile descriptors (plan 444 M1), shared by the
// pro editor and the consumer buyer surfaces so a pro and a buyer read the same
// words. The Go side (supply/descriptors.go) is the source of the vocabularies;
// this module is pinned to it by testdata/descriptor_labels.json, asserted by
// both descriptor-labels.test.ts and the supply Go suite, so a value added on one
// side only fails both. Membership and caps are enforced server-side; the
// constants below only let the editor disable chips before a round trip.

export const MAX_SPECIALTIES = 3;
export const MAX_LANGUAGES = 5;
export const MAX_DESIGNATIONS = 6;
export const MIN_LICENSED_SINCE = 1950;

export const SPECIALTY_VALUES: readonly string[] = ["first_time_buyers", "investors", "new_construction", "condos_townhomes", "luxury", "relocation", "military_va", "self_employed"];

export const LANGUAGE_VALUES: readonly string[] = ["es", "zh", "vi", "tl", "ko", "ru", "ar", "hi", "pa", "ja", "fr", "de", "pt", "it", "uk", "fa", "am", "so"];

export const DESIGNATION_VALUES: readonly string[] = ["ABR", "MRP", "SRES", "GRI", "CRS", "SFR", "RENE", "AHWD", "C2EX"];

export const SPECIALTY_LABELS: Record<string, string> = {
  first_time_buyers: "First-time buyers",
  investors: "Investors",
  new_construction: "New construction",
  condos_townhomes: "Condos & townhomes",
  luxury: "Luxury",
  relocation: "Relocation",
  military_va: "Military & VA",
  self_employed: "Self-employed buyers",
};

// English is implicit for every agent and is never a selectable language.
export const LANGUAGE_LABELS: Record<string, string> = {
  es: "Spanish",
  zh: "Chinese",
  vi: "Vietnamese",
  tl: "Tagalog",
  ko: "Korean",
  ru: "Russian",
  ar: "Arabic",
  hi: "Hindi",
  pa: "Punjabi",
  ja: "Japanese",
  fr: "French",
  de: "German",
  pt: "Portuguese",
  it: "Italian",
  uk: "Ukrainian",
  fa: "Persian",
  am: "Amharic",
  so: "Somali",
};

// One-line plain-English meaning shown beside each designation code.
export const DESIGNATION_MEANINGS: Record<string, string> = {
  ABR: "Accredited Buyer's Representative: completed training focused on representing homebuyers.",
  MRP: "Military Relocation Professional: trained to help service members and veterans move and buy with VA financing.",
  SRES: "Seniors Real Estate Specialist: trained to help buyers 50 and older with downsizing and relocating.",
  GRI: "Graduate, REALTOR Institute: completed advanced education in real estate law, finance, and ethics.",
  CRS: "Certified Residential Specialist: advanced training plus a proven record in residential sales.",
  SFR: "Short Sales & Foreclosure Resource: trained to guide buyers through short sales and foreclosures.",
  RENE: "Real Estate Negotiation Expert: completed training in negotiating for buyers and sellers.",
  AHWD: "At Home With Diversity: trained to work with clients across cultures and backgrounds.",
  C2EX: "Commitment to Excellence: completed a program on professional service standards.",
};
